import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

export function CartMaxSkuQuantityLabel() {
  const [cartMaxSkuQuantity, setCartMaxSkuQuantity] = useState()
  useEffect(() => {
    const { cartMaxSkuQuantity } = getInstoreConfig()
    setCartMaxSkuQuantity(cartMaxSkuQuantity)
  }, [])
  return cartMaxSkuQuantity ? (
    <span className="t-small c-muted-2">
      <FormattedMessage
        id="cart.config.maxSkuQuantity"
        values={{ max: cartMaxSkuQuantity }}
      />
    </span>
  ) : null
}

export default CartMaxSkuQuantityLabel
